import { Disclosure } from "@headlessui/react";
import ChevronRight from "@material-ui/icons/ChevronRight";
import type { DigitalAsset } from "../types";

interface AppleSectionProps {
  asset: DigitalAsset;
}

const AppleSection = ({ asset }: AppleSectionProps) => (
  <Disclosure defaultOpen>
    {({ open }) => (
      <div className="bg-white rounded-lg box-shadow">
        <Disclosure.Button className="disclosureBtn ml-2">
          <ChevronRight
            className={`${
              open ? "transform rotate-90" : " text-gray-500"
            } text-gray-500 w-5 h-5 `}
          />
          <span className="disclosureLabel ml-2">Apple</span>
        </Disclosure.Button>

        <Disclosure.Panel className="text-xs">
          <div className="grid grid-cols-2">
            <div className="p-2">
              <div className="grid grid-cols-1 p-2">
                <label className="mx-4 expandedLabel fontExpand">
                  Apple URL:
                </label>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mx-4 expandedData fontExpand text-blue-500 underline break-all self-center"
                  href={
                    asset.appleURL && asset.appleURL !== "NULL"
                      ? asset.appleURL
                      : ""
                  }
                >
                  {asset.appleURL && asset.appleURL !== "NULL"
                    ? asset.appleURL
                    : ""}
                </a>
              </div>
            </div>

            <div className="p-2">
              <div className="grid grid-cols-1 p-2">
                <label className="mx-4 expandedLabel fontExpand">
                  Apple Description:
                </label>
                <div className="mx-4 expandedData fontExpand">
                  {asset.appleDescription && asset.appleDescription !== "NULL"
                    ? asset.appleDescription
                    : ""}
                </div>
              </div>
            </div>
          </div>

          <div className="px-4 pt-2">
            <div className="mx-4 expandedLabel fontExpand text-quinary text-xs font-bold">
              Action Links
            </div>
          </div>

          <div className="grid grid-cols-2">
            <div className="p-2">
              <div className="grid grid-cols-1 p-2">
                <label className="mx-4 expandedLabel fontExpand">
                  Category:
                </label>
                <div className="mx-4 expandedData fontExpand">
                  {asset.appleCategoryName && asset.appleCategoryName !== "NULL"
                    ? asset.appleCategoryName
                    : ""}
                </div>
              </div>
            </div>

            <div className="p-2">
              <div className="grid grid-cols-1 p-2">
                <label className="mx-4 expandedLabel fontExpand">
                  Quick Link:
                </label>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mx-4 expandedData fontExpand text-blue-500 underline break-all self-center"
                  href={
                    asset.appleQuickLink && asset.appleQuickLink !== "NULL"
                      ? asset.appleQuickLink
                      : ""
                  }
                >
                  {asset.appleQuickLink && asset.appleQuickLink !== "NULL"
                    ? asset.appleQuickLink
                    : ""}
                </a>
              </div>
            </div>

            <div className="p-2">
              <div className="grid grid-cols-1 p-2">
                <label className="mx-4 expandedLabel fontExpand">
                  App Name:
                </label>
                <div className="mx-4 expandedData fontExpand">
                  {asset.appleAppName && asset.appleAppName !== "NULL"
                    ? asset.appleAppName
                    : ""}
                </div>
              </div>
            </div>
          </div>
        </Disclosure.Panel>
      </div>
    )}
  </Disclosure>
);

export default AppleSection;